import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';

// Cache partagé : une seule requête /plus-360 pour la sidebar, les gardes de route et les teasers.
const cache = { key: null, data: null, promise: null };
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

const fetchPlus = (key) => {
  if (cache.key === key && cache.promise) return cache.promise;
  cache.key = key; cache.data = null;
  cache.promise = axios.get(`${getApiUrl()}/plus-360`, { withCredentials: true, timeout: 15000 })
    .then(({ data }) => { cache.data = data; notify(); return data; })
    .catch(() => { cache.data = { error: true }; notify(); return cache.data; });
  return cache.promise;
};

export const reloadPlus360 = () => { cache.promise = null; if (cache.key) fetchPlus(cache.key); };
if (typeof window !== 'undefined') window.addEventListener('module-offers:updated', reloadPlus360);

export const usePlus360 = () => {
  const { user } = useAuth();
  const key = user?.user_id ? `${user.tenant_id}:${user.user_id}` : null;
  const [, tick] = useState(0);
  useEffect(() => { const fn = () => tick((n) => n + 1); listeners.add(fn); return () => listeners.delete(fn); }, []);
  useEffect(() => { if (key) fetchPlus(key); }, [key]);
  const reload = useCallback(reloadPlus360, []);
  const data = cache.key === key ? cache.data : null;
  const plus = data && !data.error ? data : null;
  return { plus, loading: !!key && !data, error: !!data?.error, locked: !!plus && !plus.enabled, reload };
};
